var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDollarIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.427 11.765L11.24 10.64a1.008 1.008 0 01-.53-1.1.957.957 0 01.879-.801 1.662 1.662 0 011.675.996.97.97 0 101.778-.777 3.557 3.557 0 00-1.94-1.894v-.725a.971.971 0 00-1.94 0v.511a2.846 2.846 0 00-2.348 2.335 2.942 2.942 0 001.546 3.182l2.186 1.118a1.009 1.009 0 01.537 1.087.918.918 0 01-.776.796h-.117a1.663 1.663 0 01-1.675-.99.97.97 0 00-1.778.77 3.622 3.622 0 002.425 2.056v.485a.97.97 0 101.94 0v-.543a2.826 2.826 0 001.889-2.25 2.91 2.91 0 00-1.565-3.13z",
    fill: "#665BFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.886 3.98a11.311 11.311 0 00-14.79-1.047l-.913-.912a.873.873 0 00-1.48.511l-.499 4.133a.873.873 0 00.97.97l4.127-.505a.867.867 0 00.51-1.48l-.866-.867a8.737 8.737 0 11-3.641 5.53.323.323 0 00-.317-.389H1.014a.33.33 0 00-.323.272A11.311 11.311 0 1019.86 3.98h.026z",
    fill: "#665BFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarIcon);
export default __webpack_public_path__ + "static/media/dollar-icon.94c510a4.svg";
export { ForwardRef as ReactComponent };